import { Switch } from "antd";
import styled, { css } from "styled-components";
import color from "../_style/color";

const ProfileSwitch = styled(Switch)`
  border: 1px solid ${color.gainsboro};
  background-color: ${color.light};

  :focus {
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .ant-switch-handle {
    border-radius: 50%;
    ${({ checked }) =>
      checked &&
      css`
        border: 1px solid ${color.primary};
      `}
  }
`;

export default ProfileSwitch;
